"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallToActions = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const Website_1 = __importDefault(require("../../../common/components/CallToActions/Website"));
const CallToActionItem_1 = __importDefault(require("./CallToActionItem"));
const CallToActionsWrapper = styled_components_1.default.div `
  padding: 24px;
  @media (min-width: 320px) and (max-width: 320px) {
    padding: 12px 0;
  }
  ul {
    padding: 0 !important;
  }
  font-size: 0.9rem;
  border-top: 1px solid #d5d5d5;
  border-bottom: 1px solid #d5d5d5;
  display: flex;
  justify-content: center;
  column-gap: 10.5vmin;

  &.bareiss {
    width: calc(100%) !important;

    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-image: ${() => "url( /images/other/bareissPngWide.png )"};
  }
`;
const MoreActionsWrapper = styled_components_1.default.div `
  visibility: ${(props) => (props.isVisible ? "visible" : "hidden")};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: rgba(0, 0, 0, 0.2);
`;
const MoreActions = styled_components_1.default.div `
  position: absolute;
  bottom: ${(props) => (props.isVisible ? "0" : `-${props.height}px`)};
  background: #ffffff;
  z-index: 11;
  width: 100%;
  padding: 24px;
  -webkit-transition: bottom 0.5s;
  -moz-transition: bottom 0.5s;
  transition: bottom 0.5s;
`;
const CallToActions = (props) => {
    const [showMoreActions, setShowMoreActions] = (0, react_1.useState)(false);
    const moreActionsRef = (0, react_1.useRef)(null);
    const { activeItem, venue } = props;
    const { content } = activeItem;
    const actions = ["phone", "email", "website", "lat"];
    const availableActions = actions.reduce((acc, curr) => {
        if (content[curr]) {
            return [...acc, { [curr]: content[curr] }];
        }
        return [...acc];
    }, []);
    if (!availableActions.length) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const actionsToShow = availableActions.length > 3
        ? [...availableActions.slice(0, 3), { more: "more" }]
        : availableActions;
    const moreActions = () => {
        setShowMoreActions(true);
    };
    const handleMoreActionsWrapperClick = (e) => {
        if (!e.target.closest(".more-actions")) {
            setShowMoreActions(false);
        }
    };
    const getRenderContainer = (type = "circle") => ({
        more: (react_1.default.createElement(CallToActionItem_1.default, { activeItem: activeItem, key: "more", icon: "more", destination: "", text: "More", type: type, onClick: moreActions })),
        email: (react_1.default.createElement(CallToActionItem_1.default, { activeItem: activeItem, key: "email", icon: "email", destination: "email", type: type, text: i18n_js_1.default.t("tab_email") })),
        website: (react_1.default.createElement(Website_1.default, { key: "website", url: content.website, type: type, text: i18n_js_1.default.t("website") })),
        phone: (react_1.default.createElement(CallToActionItem_1.default, { activeItem: activeItem, key: "call", icon: "call", destination: "call", type: type, text: i18n_js_1.default.t("tab_call") })),
        lat: (react_1.default.createElement(CallToActionItem_1.default, { activeItem: activeItem, key: "map", icon: "map", destination: "map", type: type, text: i18n_js_1.default.t("map") })),
    });
    const renderMoreActions = () => {
        const renderContainer = getRenderContainer("list");
        return availableActions.map((availableAction) => {
            const actionType = Object.keys(availableAction)[0];
            return renderContainer[actionType];
        });
    };
    const renderCallToActions = () => {
        const renderContainer = getRenderContainer();
        return actionsToShow.map((availableAction) => {
            const actionType = Object.keys(availableAction)[0];
            return renderContainer[actionType];
        });
    };
    const bareissClass = venue && venue.brandSlug === "bareiss" ? "bareiss" : "";
    return (react_1.default.createElement(CallToActionsWrapper, { className: `${bareissClass}` },
        renderCallToActions(),
        availableActions.length > 3 && (react_1.default.createElement(MoreActionsWrapper, { onClick: handleMoreActionsWrapperClick, isVisible: showMoreActions },
            react_1.default.createElement(MoreActions, { className: "more-actions", isVisible: showMoreActions, height: moreActionsRef.current ? moreActionsRef.current.offsetHeight : 0, ref: moreActionsRef },
                react_1.default.createElement(material_1.List, null, renderMoreActions()))))));
};
exports.CallToActions = CallToActions;
const mapStoreToProps = (store) => ({
    venue: store.getValue("venue"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.CallToActions);
